import React from 'react';
import {Controller} from "react-hook-form";
import PropTypes from "prop-types";
import LabelToggle from "../labelToggle";

const FormCheckbox = React.forwardRef(({name, checked, control, onChange: myOnChange = null, ...rest}, ref) => {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={checked}
            render={({field: {value, onChange}}) => {
                return <LabelToggle {...rest}
                                    ref={ref}
                                    onChange={(e) => {
                                        onChange(e);
                                        if (myOnChange != null) myOnChange(!value);
                                    }}
                                    checked={value}/>
            }}/>
    );
});

FormCheckbox.PropsTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
};

export default FormCheckbox;